/**
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business レポートカテゴリの定義。API 側と一致させる。
 * @graph-connects none
 */
export const REPORT_CATEGORIES = [
  '解約分析',
  '顧客体験',
  'スタイリング品質',
  '売上・KPI',
  'アイテム・在庫',
  'マーケティング',
  'オペレーション',
  'その他',
] as const;

/**
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business レポートカテゴリの型。
 * @graph-connects none
 */
export type ReportCategory = (typeof REPORT_CATEGORIES)[number];

/**
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business レポート一覧用の要約型（HTML本文を含まない）。
 * @graph-connects none
 */
export interface ReportSummary {
  id: string;
  title: string;
  category: ReportCategory;
  summary: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

/**
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business レポート詳細型（HTML本文を含む全フィールド）。
 * @graph-connects none
 */
export interface ReportDetail {
  id: string;
  title: string;
  category: ReportCategory;
  summary: string;
  htmlContent: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  isDeleted: boolean;
}

/**
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business レポート一覧レスポンス型。
 * @graph-connects none
 */
export interface ReportListResponse {
  reports: ReportSummary[];
}

/**
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business レポート詳細レスポンス型。canEdit で投稿者かどうかを返す。
 * @graph-connects none
 */
export interface ReportDetailResponse {
  canEdit: boolean;
  report: ReportDetail;
}
